import { useState } from 'react'
import { useLang } from '../lib/LangContext'

const STEPS = [
  { icon: '📦', key: 'step1' },
  { icon: '🔄', key: 'step2' },
  { icon: '🔔', key: 'step3' },
  { icon: '📊', key: 'step4' },
]

export default function Onboarding({ onComplete, onGoToAdd }) {
  const { t, lang, changeLang } = useLang()
  const [step, setStep] = useState(0)
  const [showExisting, setShowExisting] = useState(false)

  const isLast = step === STEPS.length - 1

  function handleNext() {
    if (isLast) setShowExisting(true)
    else setStep(s => s + 1)
  }

  function handleEnterStock() {
    onComplete()
    onGoToAdd()
  }

  return (
    <div style={{ minHeight: '100vh', background: 'var(--cream)', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '1.5rem' }}>

      {/* LOGO + LANGUE */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', maxWidth: 420, marginBottom: '2rem' }}>
        <div style={{ fontFamily: 'Fraunces, serif', fontSize: 24, color: 'var(--charcoal)' }}>
          Stock<span style={{ color: 'var(--sage)', fontStyle: 'italic' }}>O</span>
        </div>
        <div style={{ display: 'flex', gap: 6 }}>
          {['fr', 'en'].map(code => (
            <button key={code} onClick={() => changeLang(code)} style={{
              padding: '5px 12px', borderRadius: 50, fontSize: 12, cursor: 'pointer',
              border: `1.5px solid ${lang === code ? 'var(--sage)' : 'var(--cream-dark)'}`,
              background: lang === code ? 'var(--sage-pale)' : 'var(--warm-white)',
              color: lang === code ? 'var(--sage-dark)' : 'var(--muted)',
              fontWeight: lang === code ? 600 : 400,
              fontFamily: 'DM Sans, sans-serif'
            }}>
              {code === 'fr' ? '🇫🇷 FR' : '🇬🇧 EN'}
            </button>
          ))}
        </div>
      </div>

      {!showExisting ? (
        <div style={{ background: 'var(--warm-white)', border: '1px solid var(--cream-dark)', borderRadius: 'var(--radius-xl)', padding: '2rem 1.75rem', width: '100%', maxWidth: 420, boxShadow: 'var(--shadow-lg)', animation: 'slideUp 0.4s cubic-bezier(0.16,1,0.3,1)' }}>

          {/* TITRE */}
          {step === 0 && (
            <div style={{ marginBottom: '1.5rem' }}>
              <div style={{ fontFamily: 'Fraunces, serif', fontSize: 26, color: 'var(--charcoal)', marginBottom: 8 }}>{t('onboarding_welcome')}</div>
              <div style={{ fontSize: 13, color: 'var(--muted)', lineHeight: 1.6 }}>{t('onboarding_sub')}</div>
            </div>
          )}

          {/* STEP CARD */}
          <div style={{ background: 'var(--sage-pale)', borderRadius: 'var(--radius-lg)', padding: '1.5rem', marginBottom: '1.5rem', textAlign: 'center' }}>
            <div style={{ fontSize: 48, marginBottom: 12 }}>{STEPS[step].icon}</div>
            <div style={{ fontFamily: 'Fraunces, serif', fontSize: 18, color: 'var(--charcoal)', marginBottom: 8 }}>
              {t(`onboarding_${STEPS[step].key}_title`)}
            </div>
            <div style={{ fontSize: 13, color: 'var(--muted)', lineHeight: 1.7 }}>
              {t(`onboarding_${STEPS[step].key}_desc`)}
            </div>
          </div>

          {/* INDICATEUR */}
          <div style={{ display: 'flex', gap: 6, justifyContent: 'center', marginBottom: '1.5rem' }}>
            {STEPS.map((_, i) => (
              <div key={i} style={{
                width: i === step ? 20 : 6, height: 6,
                borderRadius: 3,
                background: i === step ? 'var(--sage)' : 'var(--cream-dark)',
                transition: 'all 0.3s ease'
              }} />
            ))}
          </div>

          {/* BOUTONS */}
          <div style={{ display: 'flex', gap: 10 }}>
            {step > 0 && (
              <button className="btn-cancel" onClick={() => setStep(s => s - 1)} style={{ flex: 1 }}>
                {t('onboarding_prev')}
              </button>
            )}
            <button className="btn-primary" onClick={handleNext} style={{ flex: 2 }}>
              {isLast ? t('onboarding_start') : t('onboarding_next')}
            </button>
          </div>
        </div>
      ) : (
        /* ÉCRAN BOUTIQUE EXISTANTE */
        <div style={{ background: 'var(--warm-white)', border: '1px solid var(--cream-dark)', borderRadius: 'var(--radius-xl)', padding: '2rem 1.75rem', width: '100%', maxWidth: 420, boxShadow: 'var(--shadow-lg)', animation: 'slideUp 0.4s cubic-bezier(0.16,1,0.3,1)' }}>

          <div style={{ textAlign: 'center', marginBottom: '1.5rem' }}>
            <div style={{ fontSize: 44, marginBottom: 12 }}>🏪</div>
            <div style={{ fontFamily: 'Fraunces, serif', fontSize: 20, color: 'var(--charcoal)', marginBottom: 8 }}>
              {t('onboarding_existing')}
            </div>
            <div style={{ fontSize: 13, color: 'var(--muted)', lineHeight: 1.7 }}>
              {t('onboarding_existing_desc')}
            </div>
          </div>

          <div style={{ background: 'var(--amber-pale)', border: '1px solid #E8C080', borderRadius: 'var(--radius-md)', padding: '12px 14px', marginBottom: '1.5rem', fontSize: 12, color: '#633806', lineHeight: 1.7 }}>
            ⚠ {t('onboarding_existing_desc')}
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            <button className="btn-primary" onClick={handleEnterStock}>
              {t('onboarding_enter_stock')}
            </button>
            <button className="btn-cancel" onClick={onComplete} style={{ padding: 12, fontSize: 13 }}>
              {t('onboarding_skip')}
            </button>
          </div>
        </div>
      )}
    </div>
  )
}
